import { render } from "./PlatformLogsTable.vue?vue&type=template&id=91ef2eb6&scoped=true&ts=true"
import script from "./PlatformLogsTable.vue?vue&type=script&lang=ts"
export * from "./PlatformLogsTable.vue?vue&type=script&lang=ts"

import "./PlatformLogsTable.vue?vue&type=style&index=0&id=91ef2eb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91ef2eb6"]])

export default __exports__